{
  "label": "Anwendung",
  "name": "Name",
  "model": {
    "declination": "Modell",
    "type": "Typ"
  },
  "versionNumber": "Versionsnummer",
  "serialNumber": "Seriennummer",
  "terminalName": "Terminalname",
  "windowsUserAccount": "Windows-Benutzerkonto",
  "sector": "Sektor",
  "connectivity": "Konnektivität",
  "certificate": "Zertifikat",
  "state": "Status",
  "states": {
    "activated": "Aktiviert",
    "deactivated": "Deaktiviert",
    "registered": "Neu"
  },
  "actions": {
    "scheduled": {
      "title": "Sind Aktionen in Bearbeitung?",
      "yes": "Ja",
      "no": "Nein",
      "error": "Nicht definiert"
    }
  },
  "additionalMetadata": {
    "title": "Zusätzliche Metadaten",
    "username": "Benutzername",
    "installationDate": "Installationsdatum",
    "computerName": "Computername",
    "licenseId": "Lizenznummer: {value}",
    "options": {
      "title": "Optionen",
      "numericSoftware": {
        "1": "Fernwirkstationen: {value}",
        "2": "Ablaufdatum der Lizenz: {value}"
      }
    }
  },
  "firmwareVersion": "Firmware-Version",
  "updateCertificate": "Zertifikat aktualisieren",
  "updateState": {
    "activate": {
      "title": "Aktivieren",
      "execute": "Anwendung aktivieren",
      "description": "Anwendung {name} wird aktiviert."
    },
    "deactivate": {
      "title": "Deaktivieren",
      "execute": "Anwendung deaktivieren",
      "description": "Anwendung {name} wird deaktiviert.",
      "warning": "Eine deaktivierte Anwendung profitiert nicht mehr von automatischen und manuellen Zertifikatsaktualisierungen.",
      "error": "Diese Anwendung kann nicht deaktiviert werden, da ein Vorgang geplant ist oder ausgeführt wird."
    }
  },
  "month": "{n} Monat | {n} Monate",
  "year": "{n} Jahr | {n} Jahre",
  "dateFormat": "YYYY/MM/DD hh:mm A",
  "empty": "Keine Anwendung gefunden",
  "delete": {
    "execute": "Anwendung löschen",
    "description": "Anwendung {name} wird gelöscht.",
    "warning": "Die mit der Anwendung verbundenen Vorgänge werden ebenfalls gelöscht.",
    "error": "Diese Anwendung kann nicht gelöscht werden, da ein Vorgang geplant ist oder ausgeführt wird."
  },
  "description": {
    "certificateValidityDate": "Gültigkeitsdatum des Zertifikats",
    "communicationProtocol": "Kommunikationsprotokoll",
    "configurationApplicationDate": "Datum der Parametrierungsanwendung",
    "connectivity": "Konnektivität",
    "firmwareVersion": "Firmware-Version",
    "firstCommissioningDate": "Datum der ersten Inbetriebnahme",
    "gsmFrequencyBand": "GSM-Frequenzband",
    "idCard": "ID-Karte",
    "lastChange": "Letzte Änderung",
    "lastConnection": "Letzte Verbindung",
    "lastFirmwareUpdate": "Letztes Firmware-Update",
    "lastRebootDate": "Datum des letzten Neustarts",
    "mobileNetwork": "Mobilfunknetz",
    "model": "Modell",
    "name": "Name",
    "serialNumber": "Seriennummer",
    "state": "Status",
    "terminalName": "Terminalname",
    "title": "Beschreibung",
    "type": "Typ",
    "windowsUsername": "Windows-Benutzername"
  },
  "certificateForm": {
    "expirationDate": "Ablaufdatum des Zertifikats",
    "certificateOrigin": "Herkunft des Zertifikats",
    "lastUpdate": "Letzte Aktualisierung des Zertifikats"
  },
  "operation": {
    "cancelAction": {
      "title": "Vorgang abbrechen",
      "confirm": {
        "title": "Möchten Sie diesen Vorgang wirklich abbrechen?",
        "description": "Dieser Vorgang wird abgebrochen."
      }
    },
    "updateAction": {
      "title": "Vorgang aktualisieren"
    },
    "unitary": "Einzeln",
    "campaign": "Kampagne"
  },
  "back": "Zurück"
}
